// src/pages/AchieveDetail.jsx
import React, { useEffect, useRef } from 'react';
import './AchieveDetail.css';

export default function AchieveDetail({ item, onClose, scrollRootRef }) {
  const rootRef = useRef(null);

  // En yakın kaydırılabilir ebeveyni bul
  const getScrollParent = (el) => {
    if (!el) return null;
    let node = el.parentElement;
    while (node) {
      const style = window.getComputedStyle(node);
      const canScrollY =
        /(auto|scroll)/.test(style.overflowY) && node.scrollHeight > node.clientHeight;
      if (canScrollY) return node;
      node = node.parentElement;
    }
    return null;
  };

  useEffect(() => {
    // Öncelik: dışarıdan verilen ref -> otomatik bulunan scroll parent -> window
    const target =
      (scrollRootRef && scrollRootRef.current) ||
      getScrollParent(rootRef.current) ||
      window;

    if (target === window) {
      window.scrollTo({ top: 0, behavior: 'instant' });
    } else {
      // bazı modal animasyonlarıyla çakışmaması için küçük bir gecikme iyi olur
      requestAnimationFrame(() => {
        try {
          target.scrollTo({ top: 0, behavior: 'instant' });
        } catch {
          target.scrollTop = 0; // eski tarayıcı fallback
        }
      });
    }
  }, [item, scrollRootRef]);

  // item: Achieve kartından gelen veri (title, org, vs.)
  const topBadges = [
    { img: 'https://picsum.photos/seed/org/96/96', label: 'Verilen Kurum', value: item?.org || 'MultiGroup Community' },
    { img: 'https://picsum.photos/seed/participants/96/96', label: 'Program Katılım Sayısı', value: '33 Katılımcı' },
    { img: 'https://picsum.photos/seed/owner/96/96', label: 'Belge Sahibi', value: 'Alperen Serkan Alç' },
  ];

  const units = [
    { title: 'Ünite 1: Swift ile Programlamanın Temelleri' },
    { title: 'Ünite 2: Etkileşim ve Listeleme Ustalığı' },
    { title: 'Ünite 3: Veri Yönetimi ve API Entegrasyonları' },
    { title: 'Ünite 4: İleri SwiftUI Teknikleri ve Kalite Güvencesi' },
  ];

  const instructors = [
    { name: 'Mehmet Nuri Yaman', title: 'CEO at lodos.io' },
    { name: 'Mehmet Nuri Yaman', title: 'CEO at lodos.io' },
    { name: 'Mehmet Nuri Yaman', title: 'CEO at lodos.io' },
  ];

  const skills = ['Yazılım Geliştirme', 'Mobil Geliştirme', 'iOS Geliştirme', 'Uygulama Geliştirme'];

  const similar = [
    { id: 1, title: 'Modern Android Programming Course' },
    { id: 2, title: 'Modern Android Programming Course' },
    { id: 3, title: 'Modern Android Programming Course' },
  ];

  return (
    <div ref={rootRef} className="achieve">
      <div className="achieve__badges">
        {topBadges.map((b, i) => (
          <div className="achieve-badge" key={i}>
            <div className="badge-thumb">
              <img src={b.img} alt={b.value} />
            </div>
            <div className="badge-content">
              <div className="badge-label">{b.label}</div>
              <div className="badge-value">{b.value}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="achieve__grid">
        <div className="achieve__left">
          <section className="card program-summary">
            <div className="section-label">Etkinlik Açıklaması</div>
            <h1 className="program-title">{item?.title || 'Modern iOS Programming Course - Katılım Sertifikası'}</h1>
            <p className="program-desc">
              Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's
              standard dummy text ever since the 1500s…
            </p>

            <div className="program-meta">
              <div className="meta">
                <span className="meta-label">Veriliş Tarihi</span>
                <span className="meta-value">19 Ağustos 2025</span>
              </div>
              <div className="meta">
                <span className="meta-label">Belge Türü</span>
                <span className="meta-value">Katılım Sertifika</span>
              </div>
            </div>

            <div className="program-actions">
              <button className="btn-primary">Sertifikayı Paylaş</button>
              <button className="btn-ghost" onClick={onClose}>Kapat</button>
            </div>
          </section>

          <section className="card units">
            <div className="section-label">Etkinlik Açıklaması</div>
            <ul className="unit-list">
              {units.map((u, i) => (
                <li key={i} className="unit-item">
                  <span className="unit-check">✓</span>
                  <div>
                    <div className="unit-title">{u.title}</div>
                    <div className="unit-desc">
                      Lorem ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                      industry’s standard dummy text…
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </section>

          <section className="card instructors">
            <div className="section-label">Program Eğitmenleri</div>
            <div className="instructor-list">
              {instructors.map((ins, i) => (
                <div key={i} className="instructor-item">
                  <div className="avatar" />
                  <div className="instructor-info">
                    <div className="instructor-name">{ins.name}</div>
                    <div className="instructor-title">{ins.title}</div>
                  </div>
                </div>
              ))}
            </div>
          </section>

          <section className="card skills">
            <div className="section-label">Kazanılan Kazanımlar</div>
            <div className="skill-tags">
              {skills.map((s, i) => (
                <span key={i} className="tag">{s}</span>
              ))}
            </div>
          </section>

          <section className="card similar">
            <div className="section-label">Benzer Sertifikasyon Programları (Opsiyonel)</div>
            <div className="similar-row">
              {similar.map((s) => (
                <div key={s.id} className="similar-card">
                  <div className="similar-thumb" />
                  <div className="similar-title">{s.title}</div>
                </div>
              ))}
            </div>
          </section>
        </div>

        <div className="achieve__right">
          <div className="card preview">
            <div className="certificate-frame">
              <div className="certificate-thumb">Certificate Preview</div>
            </div>
          </div>

          <div className="card empty-slot" />
        </div>
      </div>
    </div>
  );
}